 import request from '@/utils/ajax'


export function saveFeishuConfig(data) {
    return request({
        url: '/wx/manage/larkBotConfig/save',
        method: 'post',
        data: data
    })
}

export function editFeishuConfig(data) {
    return request({
        url: '/wx/manage/larkBotConfig/update',
        method: 'put',
        data: data
    })
}

export function deleteFeishuConfig(data) {
    return request({
        url: '/wx/manage/larkBotConfig/delete',
        method: 'post',
        data: data
    })
}

export function buildFeishuConfigPayload(form, editing) {
    const payload = {
        name: form.robitName,
        desc: form.desc,
        hookUrl: form.hookUrl,
        status: form.status,
        signSecret: typeof form.signSecret === 'string' ? form.signSecret : ''
    }
    if (editing) payload.id = form.id
    return payload
}
